var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.44 23.64c-.46-.62-1.08-1.11-1.86-1.47-1.83-.82-3.62-1.44-5.39-1.86-1.76-.42-3.49-.64-5.19-.64s-3.43.21-5.19.64-3.58 1.04-5.44 1.86c-.75.36-1.36.85-1.81 1.47-.46.62-.69 1.31-.69 2.06V28h26.26v-2.3c0-.75-.23-1.44-.69-2.06Zm-.39 3.28H3.95V25.7c0-.49.17-.96.51-1.42.34-.46.82-.85 1.44-1.18 1.63-.82 3.29-1.41 4.97-1.79 1.68-.38 3.39-.56 5.12-.56s3.43.19 5.09.56c1.67.38 3.33.97 5 1.79.62.33 1.1.72 1.44 1.18.34.46.51.93.51 1.42v1.22ZM19.67 5.44C18.69 4.48 17.47 4 16 4s-2.69.48-3.67 1.44-1.47 2.18-1.47 3.65.49 2.74 1.47 3.72 2.2 1.47 3.67 1.47 2.69-.49 3.67-1.47 1.47-2.22 1.47-3.72-.49-2.69-1.47-3.65Zm-.78 6.59c-.78.78-1.75 1.18-2.89 1.18s-2.11-.39-2.89-1.18-1.18-1.75-1.18-2.89.39-2.11 1.18-2.89c.78-.78 1.75-1.18 2.89-1.18s2.11.39 2.89 1.18S20.07 8 20.07 9.14s-.39 2.11-1.18 2.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.54173b72169668c53c24a3657d02517a.svg";
export { ForwardRef as ReactComponent };